
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import News from '../pages/news/page';
import Terms from '../pages/terms/page';
import Privacy from '../pages/privacy/page';
import Cookies from '../pages/cookies/page';
import Admin from '../pages/admin/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/news',
    element: <News />,
  },
  {
    path: '/terms',
    element: <Terms />,
  },
  {
    path: '/privacy',
    element: <Privacy />,
  },
  {
    path: '/cookies',
    element: <Cookies />,
  },
  {
    path: '/admin',
    element: <Admin />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
